<ngx-loading-bar color="#607D8B"></ngx-loading-bar>
